import React from "react";
import { companies } from "../components/CompaniesData";
import { Flex, Box, Heading, Text} from "rebass";
import { ULink } from "../components/ULink";

const CompanyLink: React.FC<{ companyName: string }> = ({ companyName }) => {
  const company = companies.find((c) => c.title === companyName);

  if (!company) {
    return <div>Company not found</div>;
  }

  return (
    <Flex>
      <Box width={[1 / 2]}>
        <Heading as="h6" variant="catHeading">
          Company
        </Heading>
        <Text as="p" fontWeight={"bold"} my={[2, 3]}>
          <ULink to={company.page}>{company.title}</ULink>
        </Text>
      </Box>

      <Box width={[1 / 2]} textAlign={["right","right","left"]}>
        <Heading as="h6" variant="catHeading">
          Years
        </Heading>
        <Text as="p" fontWeight={"bold"} my={[2, 3]}>
          <ULink to={company.page}>{company.year}</ULink>
        </Text>
      </Box>
    </Flex>
  );
};

export default CompanyLink;
